import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './lib/theme';
import LandingPage from './components/LandingPage';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <LandingPage />
    </ChakraProvider>
  );
}

export default App;
